<script setup>
import {useBaseStore} from "~/stores/base";
import Modal from "~/components/Modal.vue";
import {Loading} from "@element-plus/icons-vue";
import {voteRemove} from "~/api/api.vote";
import Drawer from "~/components/Drawer.vue";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["close", "confirm"])

/** props **/
const props = defineProps({
  open: {default: false},
  voteId: {default: ""},
  productId: {default: ""},
})

/** data **/
const isLoading = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/

/** methods **/
const handleClose = () => {
  emits("close")
}
const handleConfirm = async () => {
  if (isLoading.value) return
  isLoading.value = true
  await voteRemove({shareId: props.voteId, shopProductId: props.productId})
  isLoading.value = false
  emits("confirm")
}

/** lifecycle **/

</script>

<template>
  <div class="modal-vote-delete-confirm-mobile" v-if="isMobile">
    <Drawer
      :open="open"
      @close="handleClose"
      :btn-close-visible="true"
      :z-index="9999"
      :position="'bottom'"
      :border-radius="'8px 8px 0 0'"
      :global-header-visible="false"
      :append-to-body="true"
    >
      <div class="modal-vote-delete-confirm-mobile-content">
        <div class="checkbox-vote">
          <span>Once deleted, your vote cannot be recovered. Are you sure you want to proceed?</span>
        </div>
        <div class="btns">
          <div class="btn-secondary" @click="handleClose">cancel</div>
          <div class="btn-primary" :class="{'btn-disabled': isLoading}" @click="handleConfirm">
            <el-icon v-if="isLoading" class="is-loading" color="white" size="16" style="margin-right: 8px">
              <Loading/>
            </el-icon>
            <span>confirm</span>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="modal-vote-delete-confirm-desktop" v-else>
    <Modal
      :open="open"
      @close="handleClose"
      :btn-close-visible="true"
      :z-index="9999"
      :append-to-body="true"
    >
      <div class="modal-vote-delete-confirm-desktop-content">
        <div class="checkbox-vote">
          <span>Once deleted, your vote cannot be recovered. Are you sure you want to proceed?</span>
        </div>
        <div class="btns">
          <div class="btn-secondary" @click="handleClose">cancel</div>
          <div class="btn-primary" :class="{'btn-disabled': isLoading}" @click="handleConfirm">
            <el-icon v-if="isLoading" class="is-loading" color="white" size="16" style="margin-right: 8px">
              <Loading/>
            </el-icon>
            <span>confirm</span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss">
@import "src/assets/config";

.modal-vote-delete-confirm-mobile-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 64px 16px 24px 16px;

  .checkbox-vote {
    display: flex;
    align-items: center;
    gap: 8px;

    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }

  .btns {
    margin-top: 50px;
    width: 100%;
    display: flex;
    gap: 8px;

    div {
      width: 100%;
    }
  }
}


.modal-vote-delete-confirm-desktop-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 64px 16px 24px 16px;

  .checkbox-vote {
    display: flex;
    align-items: center;
    gap: 8px;

    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }

  .btns {
    margin-top: 50px;
    width: 100%;
    display: flex;
    gap: 8px;

    div {
      width: 100%;
    }
  }
}
</style>
